import React from 'react'
import ExpandGridMode from './ExpandGridMode'
import OlexUploadMode from './OlexUploadMode'
import RevisionToolbar from './RevisionToolbar'
import { RevisionConfigure } from './useRevisionConfigure'

interface RevisionModeWorkspaceProps {
  revision: RevisionConfigure
}

// Takes the place of the configure drawing and panel while the draft's grid is expanded or an Olex file is uploaded.
// Leaving the mode, by applying or cancelling, goes back to the drawing.
const RevisionModeWorkspace: React.FC<RevisionModeWorkspaceProps> = ({ revision }) => {
  const close = () => revision.setMode('configure')
  const toolbar = <RevisionToolbar revision={revision} />
  return revision.mode === 'expand' ? (
    <ExpandGridMode project={revision.project} toolbar={toolbar} onClose={close} />
  ) : (
    <OlexUploadMode revision={revision} toolbar={toolbar} onClose={close} />
  )
}

export default RevisionModeWorkspace
